<section class="blog-detail-section">

    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
        <div class="loading-spinner"></div>
        <p>Chargement de l'article...</p>
    </div>

    <!-- Error State -->
    <div class="error-state" *ngIf="error && !isLoading">
        <h3 class="error-title">Erreur</h3>
        <p class="error-text">{{ error }}</p>
    </div>

    <div *ngIf="hasBlogData() && blog">
        <div class="blog-header">
            <img [src]="blog.blogMainImage || './assets/images/blog-details-default.png'" [alt]="blog.title" class="blog-image" (error)="setDefaultImage($event)">
        </div>

        <div class="blog-container">
            <div class="blog-content">
                <div class="blog-details">
                    <h1 class="blog-title">{{ blog.title }}</h1>
                    <div class="title-footer">
                        <div class="creation-date">
                            {{ blog.createdAt }}
                        </div>
                        <div class="social-links">
                            <a *ngFor="let social of socialLinks" [href]="social.url" class="social-link" target="_blank" [attr.aria-label]="social.name">
                                <img [src]="social.icon" [alt]="social.name" class="social-icon">
                            </a>
                        </div>
                    </div>

                    <div class="blog-content-text" [innerHTML]="blog.content"></div>
                </div>
            </div>
        </div>
    </div>
</section>